import { useContext } from "react";

import { EditParticipantContext } from "./EditParticipantContext";

export function useEditParticipant() {
  const context = useContext(EditParticipantContext);
  if (!context) {
    throw new Error("useEditParticipant must be used within a EditParticipantProvider");
  }
  return context;
}
